import shortenComments from '@PROJECT_ROOT/assets/shared/js/PrivateAccommodation/shortenComments';

export default function commentReviews({ commentReview, unitId }) {
    shortenComments(110, 'shorten', commentReview);
    initializeTranslateButtonEvents();

    $('#commentsContainer').on('click', '.searchPaginationList a', (e) => {
        e.preventDefault();
        const pageNumber = e.currentTarget.getAttribute('data-page');

        getReviews(pageNumber, commentReview, unitId).then((data) => {
            $('#commentsContainer').html(data);
            shortenComments(110, 'shorten', commentReview);
            $('#commentsLoader').hide();
            initializeTranslateButtonEvents();
        });
    });
}

function initializeTranslateButtonEvents() {
    document.querySelectorAll('.js-translateLink').forEach((translateLink) => {
        translateLink.addEventListener('click', () => {
            const id = translateLink.getAttribute('index');

            $(`#translation${id}`).show();
            $(`#review${id}`).hide();

            $(translateLink).css('color', 'Gray').css('text-decoration', 'none');
            $(`#translateLinkOriginal${id}`).css('color', '').css('text-decoration', '');
        });
    });

    document.querySelectorAll('.js-translateLinkOriginal').forEach((translateLink) => {
        translateLink.addEventListener('click', () => {
            const id = translateLink.getAttribute('index');

            $(`#translation${id}`).hide();
            $(`#review${id}`).show();

            $(`#translateLink${id}`).css('color', '').css('text-decoration', '');
            $(translateLink).css('color', 'Gray').css('text-decoration', 'none');
        });
    });

    document.querySelectorAll('.js-translateReplyLinkOriginal').forEach((translateLink) => {
        translateLink.addEventListener('click', () => {
            const id = translateLink.getAttribute('index');

            $(`#translatedReply${id}`).hide();
            $(`#reply${id}`).show();

            $(translateLink).css('color', 'Gray').css('text-decoration', 'none');
            $(`#translateReplyLink${id}`).css('color', '').css('text-decoration', '');
        });
    });

    document.querySelectorAll('.js-translateReplyLink').forEach((translateLink) => {
        translateLink.addEventListener('click', () => {
            const id = translateLink.getAttribute('index');

            $(`#reply${id}`).hide();
            $(`#translatedReply${id}`).show();

            $(`#translateReplyLinkOriginal${id}`).css('color', '').css('text-decoration', '');
            $(translateLink).css('color', 'Gray').css('text-decoration', 'none');
        });
    });
}

function getReviews(page, commentReview, unitId) {
    const { privateReviewUrl } = commentReview;
    $('#commentsLoader').show();
    return $.post(privateReviewUrl, { page, unitId });
}
